import React from 'react'
import ActionButtons from './ActionButtons'
import { motion } from "framer-motion";

const slideInLeft = {
    hidden: { opacity: 0, x: -80 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.8,
            ease: "easeOut",
        },
    },
};

const slideInRight = {
    hidden: { opacity: 0, x: 80 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.8,
            ease: "easeOut",
        },
    },
};

const container = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const HeroCTA2 = () => {
    return (
        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className="relative w-full bg-[#D5EAC9] rounded-[40px] flex flex-col md:flex-row items-end md:items-center gap-5 md:gap-10 justify-between pt-10 pl-4 mt-8 mb-0 md:pt-14 md:pl-12 md:mb-8">
            <motion.div variants={slideInLeft} className='w-full flex flex-col items-center md:block text-[#24201E] pr-4 md:pr-0 md:-mt-20'>
                <h2 className='text-center md:text-left font-display-fran font-semibold text-5xl md:mb-8 mb-12'>Download the <br /> AfriPay App</h2>
                <ActionButtons />
            </motion.div>
            <motion.img variants={slideInRight} src="/images/hero-cta-img2.avif" alt="Hero CTA Image 2" width={600} className='hidden md:block' />
            <motion.img variants={slideInRight} src="/images/hero-cta-mobile-img2.avif" alt="Hero CTA Image 2" width={345} className='md:hidden block' />
            <div className='absolute bottom-0 left-0 bg-[#1A2E1A] rounded-b-[40px] z-1 w-full h-20 flex items-center justify-center md:gap-8 py-6 text-white text-[10px] md:text-3xl'>
                <div className="flex items-center gap-0.5 md:gap-5">
                    <p>Digital Banking</p>
                    <span>◆</span>
                </div>
                <div className="flex items-center gap-0.5 md:gap-5">
                    <p>Digital Card Perks</p>
                    <span>◆</span>
                </div>
                <div className="flex items-center gap-0.5 md:gap-5">
                    <p>Instant online debit</p>
                    <span>◆</span>
                </div>
                <p>Crypto Transfer</p>
            </div>
        </motion.div>
    )
}

export default HeroCTA2